import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';

import './App.scss';
// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500, Register, ErrorPage } from './views/Pages';
import ResetForgetPassword from './views/Pages/ResetForgetPassword';
import LandingPage from './views/Pages/LandingPage/LandingPage';
import AxiosInstance from './components/AxiosInstance/AxiosInstance';
import { bool } from 'prop-types';

//Import for user idle handle 

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Logout from './components/Logout/Logout';
import Countdown from 'react-countdown-now';
import CustError from './views/Pages/ErrorPage/CustomizeErrorPage/CustErrorPage';

import Idle from './components/Idle/Idle';
import queryString from 'query-string';
var CryptoJS = require("crypto-js");
var model = false;

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      params: []
    };

  }

  render() {
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
    const isAuthenticated = props => {
      var newurl = ''

      if (window.location.href.includes('?')) {
        if (!window.location.href.includes('encrypt')) {
          var path = window.location.href.split('?')[0];
          var querystring_data = window.location.href.split('?')[1];
          
          if (querystring_data.includes('redirect_to_bcmuser')) {
            var current_url = window.location.href;
            
            let params = queryString.parse(current_url);

            sessionStorage.setItem("sub_Menu", "BCM User");
            sessionStorage.setItem("redirect_to_bcmuser", "true");
            sessionStorage.setItem("NewQRadar_tbBCMmDepartmentID", params.deptid)
            sessionStorage.setItem('NewQRadar_scoreCard', params.deptname);
            sessionStorage.setItem('NewQRadar_tbWFLtBCMTransactionID', -1);
            sessionStorage.setItem('NewQRadar_readOnly', params.readonly);
            sessionStorage.setItem('NewQRadar_writeOnly', params.writeonly);
            sessionStorage.setItem('NewQRadar_deleteOnly', params.deleteonly);
            sessionStorage.setItem('NewQRadar_reportOnly', params.reportonly);

            newurl = path;
          }
          else {
            newurl = path + '?encrypt=true&' + CryptoJS.AES.encrypt(querystring_data, SECRET_KEY);
          }
          window.history.replaceState({}, '', newurl);
        } else {
          var encryptquerystring = props.location.search.split('encrypt=true&')[1];
          var bytes = CryptoJS.AES.decrypt(encryptquerystring.toString(), SECRET_KEY);
          props.location.search = bytes.toString(CryptoJS.enc.Utf8);
        }
      }

      var Islogin = sessionStorage.getItem('NewQRadar_accessToken') != null ? true : false;
      return Islogin;
    }


    const UnauthenticatedRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(props) => (
        !isAuthenticated(props) ? <Component {...props} /> : <Redirect to='/' />
      )} />
    );


    const AuthenticatedRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(props) => (
        isAuthenticated(props) ? <Component {...props} /> : <Redirect to='/login' />
      )} />
    );

    return (
      <div>
        < HashRouter >
          <Switch>
            <UnauthenticatedRoute exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route exact path="/errorpage" name="Error Page" component={ErrorPage} />
            <Route exact path="/errorpage/custError" name="Error Page" component={CustError} />
            <Route path="/resetForgetPassword/:key" name="Reset Forget Password" component={ResetForgetPassword} />
            <Route exact path="/landingPage" name="Landing Page" component={LandingPage} />
            <AuthenticatedRoute path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </HashRouter >

        <Idle/>
      </div >
    );
  }
}

export default App;
